import { useStaticQuery, graphql } from "gatsby";

import { Query } from "@graphql-types";

const AllNewsQuery = (iban: string) => {
  const { allSanityNews, allSanityNewsCategory }: Query = useStaticQuery(graphql`
    query allNewsQuery {
      allSanityNews(sort: { fields: date, order: DESC }) {
        nodes {
          ...sanityNewsPreview
        }
      }
      allSanityNewsCategory {
        nodes {
          title
          region {
            ...sanityRegion
          }
        }
      }
    }
  `);

  if (allSanityNews == null) return null;

  const filteredNews = allSanityNews.nodes.filter(item => {
    if (item.region == null) return null;
    if (item.region.iban === iban) return item;

    return null;
  });

  const filteredCategories = allSanityNewsCategory.nodes.filter(item => {
    if (item.region == null) return null;

    if (item.region.iban === iban) return item;
    if (item.region.iban === process.env.GATSBY_DEFAULT_IBAN_REGION) return item;
    return null;
  });

  return { articles: filteredNews, categories: filteredCategories };
};

export default AllNewsQuery;
